import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitpodComponent } from './simple-icons-gitpod.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitpodComponent ],
    exports:      [ SimpleIconsGitpodComponent ],
    bootstrap:    []
})
export class SimpleIconsGitpodModule {}
